import React from 'react';
import { QueryProvider } from '@thd-nucleus/data-sources';
import { useStoreId } from '@thd-nucleus/experience-context';
import { KitchenCabinets } from './KitchenCabinets';

export const KitchenCabinetsContainer = (props) => {
  const storeId = useStoreId();
  const defaultVariables = {
    storeId,
    skipSpecificationGroup: false,
    skipInstallServices: true,
    skipSubscribeAndSave: true,
    skipKPF: true
  };

  return (
    <QueryProvider
      cacheKey="kitchen-cabinets-desktop"
      defaultVariables={defaultVariables}
    >
      {/* eslint-disable-next-line react/jsx-props-no-spreading */}
      <KitchenCabinets {...props} />
    </QueryProvider>
  );
};

KitchenCabinetsContainer.propTypes = {};